import React from "react";

//** Context  */
import useNewBusiness from "../../../hooks/useNewBusiness.ts";

//** NDBX Components */
import { Section } from "@arp/react-ndbx";

//** MUI Components */
import { Typography, Stack } from "@mui/material";

//* Page level components */
import SuccessfulOutcomesHeader from "./SuccessfulOutcomeHeader.jsx";

//----------------------------------------------------------------

export default function SuccessfulHeadlineHeader({ ...props }) {
	const { onChange } = { ...props };

	//* New Business data
	const { data: outcomeData } = useNewBusiness();

	const handleOnChange = (e) => {
		if (onChange) onChange(e);
	};

	return (
		<>
			<Section mb={{ xs: 4, md: 4 }} mt={2}>
				<Typography variant="h2-bold">Review & Purchase</Typography>
			</Section>
			<Section md={7} mb={4} sx={{ textAlign: "center", mx: "auto" }}>
				<Typography variant="p2">
					Hi {outcomeData?.firstName}, this is your application progress
				</Typography>
			</Section>
			{outcomeData ? (
				<Section sx={{ minWidth: `calc(100vw -  50px)` }}>
					<SuccessfulOutcomesHeader onChange={(e) => handleOnChange(e)} />
				</Section>
			) : null}
		</>
	);
}
